<template>
  <!-- <el-popover
    placement="bottom"
    trigger="hover"
    popper-class="price-popover"
    :open-delay="300"
    :append-to-body="false"
    :disabled="disabled"
  >
    <div
      slot="reference"
      class="calendar-cell mx-auto"
      :class="{
        'is-selected': selected,
        'is-disabled': !stock
      }"
    >
      <div class="calendar-cell__day">{{ date.date() }}</div>
      <template v-if="stock">
        <div class="calendar-cell__stock">{{getStockLabel(stock.lost_stock)}}</div>
        <div class="calendar-cell__price">￥{{ stock.price }}起</div>
      </template>
    </div>
    <div class="price-table">
      <div class="table">
        <div class="table-header-group price-table-head">
          <div class="table-row">
            <div class="table-cell">价格类型</div>
            <div class="table-cell">成人</div>
            <div class="table-cell">儿童</div>
            <div class="table-cell text-right">单房差</div>
          </div>
        </div>
        <div class="table-row-group price-table-body">
          <div class="table-row" v-for="i in 3" :key="i">
            <div class="table-cell">同行价</div>
            <div class="table-cell">¥ 1000</div>
            <div class="table-cell">¥ 1000</div>
            <div class="table-cell text-right">¥ 1000</div>
          </div>
        </div>
      </div>
    </div>
  </el-popover> -->

  <div
    class="calendar-cell mx-auto"
    :class="{
      'is-selected': selected,
      'is-disabled': !stock
    }"
  >
    <div class="calendar-cell__day">{{ date.date() }}</div>
    <template v-if="stock">
      <div class="calendar-cell__stock">
        {{ getStockLabel(stock.lost_stock) }}
      </div>
      <div class="calendar-cell__price whitespace-nowrap line-clamp-1">
        ￥{{ stock.price }}起
      </div>
    </template>
  </div>
</template>
<script>
export default {
  props: {
    date: Object,
    selected: Boolean,
    disabled: Boolean,
    stock: Object
  },
  mounted() {},
  methods: {
    getStockLabel(num) {
      if (num > 20) {
        return "充足";
      } else if (num > 5) {
        return "少量";
      } else if(num > 0) {
        return `仅剩${num}间`
      } else {
        return "库存现询";
        // return "二次确认";
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.calendar-cell {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  border-radius: 0.5rem;
  cursor: pointer;
  height: 70px;
  font-size: 0.75rem;
  line-height: 1rem;
  padding-left: 0.125rem;
  padding-right: 0.125rem;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  text-align: center;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  width: 68px;
  -webkit-transition-property: background-color, border-color, color, fill, stroke;
  -o-transition-property: background-color, border-color, color, fill, stroke;
  transition-property: background-color, border-color, color, fill, stroke;
  -webkit-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -o-transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  -webkit-transition-duration: 150ms;
  -o-transition-duration: 150ms;
  transition-duration: 150ms;
}
.calendar-cell:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(243, 244, 246, var(--tw-bg-opacity));
}
.calendar-cell.is-selected {
  --tw-bg-opacity: 1;
  background-color: rgba(0, 94, 220, var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.calendar-cell.is-selected .calendar-cell__day, .calendar-cell.is-selected .calendar-cell__stock, .calendar-cell.is-selected .calendar-cell__price {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
.calendar-cell.is-disabled .calendar-cell__day {
  --tw-text-opacity: 1;
  color: rgba(178, 178, 189, var(--tw-text-opacity));
}
.calendar-cell.is-disabled:hover {
  --tw-bg-opacity: 1;
  background-color: rgba(255, 255, 255, var(--tw-bg-opacity));
  cursor: not-allowed;
}
.calendar-cell__day {
  font-weight: 500;
  font-size: 1rem;
  line-height: 1.5rem;
  --tw-text-opacity: 1;
  color: rgba(25, 25, 25, var(--tw-text-opacity));
}
.calendar-cell__stock {
  --tw-text-opacity: 1;
  color: rgba(178, 178, 189, var(--tw-text-opacity));
}
.calendar-cell__price {
  font-weight: 500;
  --tw-text-opacity: 1;
  color: rgba(0, 94, 220, var(--tw-text-opacity));
}
.price-table {
  width: 350px;
}
.price-table .table-header-group {
  border-bottom: $border-base;
}
.price-table .table-header-group .table-cell {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.price-table .table-row-group .table-cell {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.price-table-body {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
::v-deep .price-popover {
  --tw-border-opacity: 1;
  border-color: rgba(255, 169, 0, var(--tw-border-opacity));
  padding-left: 1.5rem;
  padding-right: 1.5rem;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  box-shadow: 0px 2px 10px 0px rgba(255, 166, 0, 0.34);
}
::v-deep .price-popover .popper__arrow::before {
  content: " ";
  border-width: 6px;
  position: absolute;
  z-index: 1;
  display: block;
  width: 0;
  height: 0;
  border-color: transparent;
  border-style: solid;
}
::v-deep .price-popover[x-placement^="bottom"] .popper__arrow::after {
  border-bottom-color: $color-warn;
  top: 0;
}
::v-deep .price-popover[x-placement^="bottom"] .popper__arrow::before {
  top: 2px;
  margin-left: -6px;
  border-top-width: 0;
  border-bottom-color: #ffffff;
}
::v-deep .price-popover[x-placement^="top"] .popper__arrow::after {
  border-top-color: $color-warn;
  bottom: 0;
}
::v-deep .price-popover[x-placement^="top"] .popper__arrow::before {
  bottom: 2px;
  margin-left: -6px;
  border-top-color: #ffffff;
  border-bottom-width: 0;
}
</style>
